// import gates from "./gates";

export const getBaseUrl = () => {
  return "https://price-guessing.mockinaeon.workers.dev";
};
